import ModalFooter from './ModalFooter.vue'

export { ModalFooter }
export default ModalFooter
